// Both classic sites and AI sites use project_members in the admin API. Older
// project payloads can still contain an embedded map, while some callers pass
// a member array, so normalize the identity before building profile links.
export function projectMembers(project) {
  const source = project?.members;
  const entries = Array.isArray(source)
    ? source.map((member) => [null, member])
    : Object.entries(source && typeof source === "object" ? source : {});

  return entries.filter(([, member]) => member && typeof member === "object").map(([key, member]) => {
    const rawID = member.user_id || member.userID || member.sub || member.id ||
      (member.pk?.startsWith?.("user-") ? member.pk.slice(5) : member.pk) || key;
    const id = rawID == null ? "" : String(rawID);
    const guest = id.startsWith("guest-") || member.email === "guest@invalid.local";
    const name = typeof member.name === "string" ? member.name.trim() : "";
    const email = typeof member.email === "string" ? member.email.trim() : "";

    return {
      id,
      name: guest ? "Guest creator (unclaimed)" : name || email || id || "Unknown member",
      email: guest ? "" : email,
      privilege: member.privilege || "",
      superAdmin: Boolean(member.superAdmin || member.super_admin),
      profilePath: id && !guest && !id.includes("@") ? `/users/${encodeURIComponent(id)}` : null,
    };
  });
}
